import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import ArticleBody from '../ArticleBody';
import messages from '../../../messages';

const EffectsOfIsolation = () => (
  <div>
    <ArticleBody>
      <FormattedHTMLMessage tagName="p" {...messages.effectsOfIsolationBody} />
    </ArticleBody>
  </div>
);

EffectsOfIsolation.propTypes = {};

export default EffectsOfIsolation;
